
import { config } from "./config";
export  function getDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipad|ipod|android|windows phone/g.test(userAgent);
    const isTablet =
      /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);

    return 'Mobile';
    if (isMobile) return 'Mobile';
    else if (isTablet) return 'Tablet';
    else return 'Desktop';
}
export function isMobile(){
  return !(getDeviceType() == "Desktop")
}
export function isEmail(email){
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
export function editObject(obj, params, values){
    var newObj = {...obj};
    for(var i=0;i<params.length;i++){
        newObj[params[i]] = values[i];
    }
    return newObj;
}
export function setAgentCode(code){
  localStorage.setItem("AgentCode", code);
}
export function getAgentCode(){
  var agentCode = localStorage.getItem("AgentCode");
  if(IsIntNumber(agentCode)){
    var ac = parseInt(agentCode);
    if(ac >= 100){
      return ac;
    }
  }
  return 0;
}
export function setCurrentUser(user){
  var ExpireTime = new Date().getTime() / 1000;
  ExpireTime += (10 * 60 * 1000);

  user.ExpireTime = ExpireTime;    
  console.log("user to set is>", user)                
  localStorage.setItem("School7Account", JSON.stringify(user));  
}
export function getSchoolName(){
  var user = getCurrentUser();
  if(user.Role === 1){
    return "مدیریت";
  }
  else{
    for(var i=0;i<user.SelectableRoles.length;i++){
      if((user.Role == user.SelectableRoles[i].role.id)&&(user.SchoolId == user.SelectableRoles[i].school.id)){
        return user.SelectableRoles[i].school.schoolName;
      }
    }
    return "داشبورد";
  }

}
export function generateRandomUString(howmanycharacters){
    const charBank = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    let random= '';
    for (let i = 0; i < howmanycharacters ; i++) {
        random+= charBank[parseInt(Math.random() * charBank.length)];
    }

    return random;
}

export function getCurrentUser(){
    var str = localStorage.getItem("School7Account");
    if(str){
      var user = JSON.parse(str);
      if(user){
        if(user.agentCode != null){
          if(IsIntNumber(user.agentCode)){
            return {UserId:user.UserId, Mobile:user.Mobile, Firstname:user.Firstname, Lastname:user.Lastname, Token:user.Token, Role:user.Role, RoleTitle:user.RoleTitle
              , SchoolId:user.SchoolId, SchoolTitle:user.SchoolTitle
              , StudentId:user.StudentId, StudentNationalId:user.StudentNationalId, StudentFirstname:user.StudentFirstname, StudentLastname:user.StudentLastname, 
              ExpireTime:user.ExpireTime, SelectableRoles:user.SelectableRoles,
              agentCode:user.agentCode
              };
          }
          else{
            console.log("agent code in get user is>", user.agentCode)
          }
        }
      }
    }
    return {UserId:"", Mobile:"", Firstname:"", Lastname:"", Token:"", Role:0, RoleTitle:""
    , SchoolId:"", SchoolTitle:""
    , StudentId:"", StudentNationalId:"", StudentFirstname:"", StudentLastname:""
    , ExpireTime:0, SelectableRoles:[], agentCode:0};
  }
export function clearCurrentUser(){
    localStorage.removeItem("School7Account");
  }
export function getTrustedUser(){
  var user = getCurrentUser();
  var res = {
    userId:user.UserId,
    token:user.Token,
    schoolId:user.SchoolId,
    studentId:user.StudentId,
    role:user.Role,
    agentCode:user.agentCode,
  };
  return res;
}
  export function getUserRoleTitle(role){
    switch(role){
      case UserRoles.Admin: return "ادمین";
      case UserRoles.Manager: return "مدیر مدرسه";
      case UserRoles.Assistant: return "معاون مدرسه";
      case UserRoles.Teacher: return "معلم";
      case UserRoles.Student: return "دانش آموز";
      case UserRoles.Parent: return "والد دانش آموز";
      case UserRoles.Agent: return "نماینده فروش";
    }
    return "-";
  }
  export function getCurrentUserRole(){
    var user = getCurrentUser();
    if(user == null) return 0;
    return user.Role;
    
  }
  export function isLogedIn(){
    var user = getCurrentUser();
    if(user == null) return false;
    if(user.UserId == "") return false;
    var ExpireTime = new Date().getTime() / 1000;
    if(user.Role <=0) return false;
    
    if(user.ExpireTime>= ExpireTime) return true;
    
    return false;
    
  }
  export function getScore(deg, score){
    if((deg<1)||(deg>6)) return toPersianDigits(score);
    if(score>describableScores.good) return 'خ خ';
    if(score>describableScores.acceptable) return 'خ';
    if(score>describableScores.rejected) return 'ق ق';
    return 'ن ت';
  }

  export function SeperatePrice(x){
    if(x === 0) return "0";
    if(x === "0") return "0";
    if(!x) return "";
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  export function SeperateDate(x){
    var tmp = x.toString();
    if(tmp.length === 8){
      return tmp.substring(0, 4) + "/" + tmp.substring(4, 6) + "/" + tmp.substring(6, 8);
    }else{
      return tmp;
    }
  }
  export function SeperateTime(x){
    var tmp = x.toString();
    while(tmp.length <6){ tmp = "0" +  tmp;
    }
    return tmp.substring(0, 2) + ":" + tmp.substring(2, 4) + ":" + tmp.substring(4, 6);
  }
  export function IsMobileValid(mobile){
    if(mobile === null){
      return {valid:false, msg:"موبایل مشخص نشده است"};
    }
    if(mobile.trim() === ""){
      return {valid:false, msg:"موبایل مشخص نشده است"};
    }
    if(mobile.trim().length != 11){
      return {valid:false, msg:"موبایل باید 11 رقمی باشد"};
    }
    if(mobile.indexOf("09") != 0){
      return {valid:false, msg:"موبایل باید با 09 شروع شود"};
    }
    return {valid:true, msg:"معتبر است"};
  }
export function IsValidNationalCode(input){
    if(input.length == 12){ 
      if(IsNumber(input)) return true;
      return false;
    }
    if (!/^\d{10}$/.test(input)) return false; // فقط ۱۰ رقم
    
    // همه ارقام یکی نباشن
    if (/^(\d)\1{9}$/.test(input)) return false;
    
    const check = parseInt(input[9]);
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(input[i]) * (10 - i);
    }
    const remainder = sum % 11;
    
    if((remainder < 2 && check === remainder) || 
           (remainder >= 2 && check === 11 - remainder)){
            return true;
           }
           else{
            return false;
           }
  };
export function RemoveIntZeros(n) {
    while (String(n).substr(0, 1) == "0") {
        n = String(n).substr(1, n.length - 1);
    }
    if (n == "") return 0;
    else return parseInt(n);
}
export function IsIntNumber(n) {
    if (n == null) return false;
    if (isNaN(n)) return false;
    n = String(n);
   // if(n === 0) return true;
   // if(n === "0") return true;
    if (n == "") return false;
    if (n % 1 != 0) return false;
    while (String(n).substr(0, 1) == "0") {
        n = String(n).substr(1, n.length - 1);
    }
    if (n == "") return true;
    if (n != parseInt(n)) return false;
    return true;
}
export function IsNumber(n) {
    if (n == null) return false;
    if (n == "") return false;
    if (isNaN(n)) return false;
    while (String(n).substr(0, 1) == "0") {
        n = String(n).substr(1, n.length - 1);
    }
    if (n == "") return true;
    if (n != parseFloat(n)) return false;
    return true;
}
export function ReplaceStr(text, search, replace){
    while(text.indexOf(search) >=0){
      text = text.replace(search, replace);
    }
    return text;
  }
export function getWeekDayName(ind){
  switch(ind){
    case 0: return "شنبه";
    case 1: return "یکشنبه";
    case 2: return "دوشنبه";
    case 3: return "سه شنبه";
    case 4: return "چهارشنبه";
    case 5: return "پنچشنبه";
    case 6: return "جمعه";
  }
  return "";
}
export function getTimeIndexName(ind){
  switch(ind){
    case 0: return "زنگ اول";
    case 1: return "زنگ دوم";
    case 2: return "زنگ سوم";
    case 3: return "زنگ چهارم";
    case 4: return "زنگ پنجم";
    case 5: return "زنگ ششم";
  }
  return "";
}
export function getMonthName(ind){
  ind = parseInt(ind);
  switch(ind){
    case 1: return "فروردین";
    case 2: return "اردیبهشت";
    case 3: return "خرداد";
    case 4: return "تیر";
    case 5: return "مرداد";
    case 6: return "شهریور";
    case 7: return "مهر";
    case 8: return "آبان";
    case 9: return "آذر";
    case 10: return "دی";
    case 11: return "بهمن";
    case 12: return "اسفند";
  }
  return "";
}
export function getDegreeChar(deg){
  if(deg == 1) return "اول";
  if(deg == 2) return "دوم";
  if(deg == 3) return "سوم";
  if(deg == 4) return "چهارم";
  if(deg == 5) return "پنجم";
  if(deg == 6) return "ششم";
  if(deg == 7) return "هفتم";
  if(deg == 8) return "هشتم";
  if(deg == 9) return "نهم";
  if(deg == 10) return "دهم";
  if(deg == 11) return "یازدهم";
  if(deg == 12) return "دوازدهم";

  return "";
}
export function getEducationName(){
  return toPersianDigits("1406 - 1405");
}
export function toPersianDigits(num){
  return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
};  
export function toEnglishDigits(str) {
  str = String(str);
  return str.replace(/[\u06F0-\u06F9\u0660-\u0669]/g, function (d) {
    // یونیکد فارسی: \u06F0 تا \u06F9
    // یونیکد عربی:  \u0660 تا \u0669
    var charCode = d.charCodeAt(0);
    if (charCode >= 0x06F0 && charCode <= 0x06F9) {
      return charCode - 0x06F0; // فارسی
    } else if (charCode >= 0x0660 && charCode <= 0x0669) {
      return charCode - 0x0660; // عربی
    }
    return d;
  });
};  
  //--------------------------------------------------------------------------------------------------------------------------
export const UserRoles = {
    Any:0,
    Admin:1,
    Manager:2,
    Assistant:3,
    Teacher:4,
    Student:5,
    Parent:6,
    Agent:7
};
export const scoreTypes = {
    ContinualTest:1,
    MonthAverage:2,
};
export const describableScores = {
  veryGood:20,
  good:15,
  acceptable:12,
  rejected:8
}
export const colors = [
  "#3366CC", // آبی پررنگ
  "#DC3912", // قرمز ملایم
  "#fc9f14ff", // نارنجی
  "#109618", // سبز متوسط
  "#990099", // بنفش تیره
  "#0099C6", // آبی فیروزه‌ای
  "#DD4477", // صورتی تمشکی
  "#66AA00", // سبز روشن
  "#B82E2E", // قرمز زرشکی
  "#316395", // آبی نفتی
  "#994499", // بنفش
  "#22AA99", // سبز آبی ملایم
  "#AAAA11", // زرد زیتونی
  "#6633CC", // بنفش آبی
  "#ce6903ff", // نارنجی تیره
  "#8B0707", // قهوه‌ای مایل به قرمز
  "#329262", // سبز زمردی
  "#5574A6", // آبی فولادی
  "#3B3EAC", // آبی مایل به بنفش
  "#A680B8"  // بنفش روشن
];
export const lightColors = [
  "#FFD966", // زرد روشن
  "#FFB6B9", // صورتی ملایم
  "#A0E7E5", // فیروزه‌ای
  "#B4F8C8", // سبز نعناعی
  "#FBE7C6", // کرم هلویی
  "#C8E3D4", // سبز پاستلی
  "#F6D6AD", // بژ روشن
  "#E3C9FF", // بنفش پاستلی
  "#FDC5F5", // صورتی روشن
  "#C0FDFB", // آبی آبی روشن
  "#FFECB3", // کرم روشن
  "#C2F970", // سبز لیمویی
  "#FAD4D8", // صورتی کمرنگ
  "#E5EDB7", // زیتونی روشن
  "#F8C8DC", // رز پاستلی
  "#C9E4DE", // سبز دودی
  "#FDE2E4", // کرم گل‌بهی
  "#FFF1B6", // زرد روشن پاستلی
  "#CCE2CB", // سبز کمرنگ
  "#EAD5E6"  // بنفش کم‌رنگ
];
export const maxRowsPerPageInDisiplineGradeSheet = 10;
export function prepareDisiplineGradeSheetToPrint(gss){
  gss["pages"] = [];
  var tmp = [...gss.items];
  while(tmp.length>0){
    var co = 0;
    var items = [];
    while((tmp.length>0)&&(co<maxRowsPerPageInDisiplineGradeSheet)){
      items.push({...tmp[0]});
      co++;
      tmp.splice(0, 1);
    }
    gss["pages"].push(items);
  }
  if(gss["pages"].length == 0){
    gss["pages"].push([
      {
        comment:"هیچ موردی ثبت نشده است",
        disorderTypeTitle:"",
        issueDate:0,
        negativeScore:0,
        positiveScore:0
      }
    ])
  }
  return gss;
}